<div class="page container-v2">
  <div class="BreadcrumbsSlot">
    <sd-breadcrumbs></sd-breadcrumbs>
  </div>

  <div class="content">
    <sd-order-confirmation-info-title></sd-order-confirmation-info-title>
    <sd-order-confirmation-info-body></sd-order-confirmation-info-body>
    <sd-order-confirmation-info-buttons></sd-order-confirmation-info-buttons>
    <sd-order-confirmation-info-invoice-button></sd-order-confirmation-info-invoice-button>
  </div>

  <div class="recomendations col-12">
    <sd-product-carousel [position]="1"></sd-product-carousel>
  </div>
</div>
